import { type FunctionComponent, type PropsWithChildren, createContext, useState } from 'react';
import { type RemovedProjectItem } from '../../../types/project.types';

export type ProjectUndoContextState = {
	lastRemovedItems: RemovedProjectItem[] | null;
	setLastRemovedItems: (items: RemovedProjectItem[] | null) => void;
};

const initialState: ProjectUndoContextState = {
	lastRemovedItems: null,
	setLastRemovedItems: () => {}
};

export const ProjectUndoContext = createContext<ProjectUndoContextState>(initialState);

export const ProjectUndoContextProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
	const [lastRemovedItems, setLastRemovedItems] = useState<RemovedProjectItem[] | null>(null);

	const value = {
		lastRemovedItems,
		setLastRemovedItems
	};

	return <ProjectUndoContext.Provider value={value}>{children}</ProjectUndoContext.Provider>;
};
